import { Component, Input } from "@angular/core";

@Component({
    selector: "gene-close-icon",
    templateUrl: "./close-icon.component.html",
    styleUrls: ["./close-icon.component.css"],
    standalone: true
})
export class CloseIconComponent {
    @Input() width!: string;
    @Input() height!: string;
    @Input() fill!: string;
};
